import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export default {
  async create(projectId: Id, data: ApiRequests['api.v1.asset-type.store']) {
    return await api(route('api.v1.asset-type.store', projectId), 'post', {
      data,
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.asset-type.update']) {
    return await api(route('api.v1.asset-type.update', id), 'patch', {
      data,
    });
  },

  async delete(id: Id) {
    return await api(route('api.v1.asset-type.destroy', id), 'delete');
  },
};
